import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";
import ContactForm from "./ContactForm";

export default function ContactSection({ 
  title = "Kontakt mig for en snak", 
  description = "Har du spørgsmål, eller ønsker du at bestille en tid til clairvoyance, hypnose eller parterapi? Skriv eller ring til mig i dag." 
}) {
  return (
    <section id="kontakt" className="bg-neutral-950 py-24 relative overflow-hidden">
      {/* Watermark Background */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden z-0 flex items-center justify-center lg:justify-end lg:pr-12">
        <img 
          src="https://assets.auxodev.dk/assets/a3d6ce76-96f3-4371-8c41-b2ca08e435bb/john-calmar-vandmaerke-logo.png" 
          className="w-[500px] md:w-[700px] h-auto opacity-5 invert brightness-200 object-contain select-none" 
          alt="" 
          aria-hidden="true"
        />
      </div>

      <div className="max-w-[1400px] mx-auto px-6 grid grid-cols-1 lg:grid-cols-12 gap-12 relative z-10">
        <div className="lg:col-span-7">
          <ContactForm />
        </div>

        <div className="lg:col-span-5 text-left space-y-8">
          <div className="space-y-4">
            <h2 className="text-4xl md:text-5xl font-light text-white leading-tight">
              {title}
            </h2>
            <p className="text-neutral-400 font-light leading-relaxed">
              {description}
            </p>
          </div>

          <div className="space-y-6 text-sm">
            <div className="flex items-start gap-4">
              <div className="text-white shrink-0 pt-1">
                <MapPin className="w-6 h-6" />
              </div>
              <div>
                <p className="font-medium text-white">Adresse</p>
                <p className="text-neutral-400 mt-0.5">Lykkesholms Allé 102, 1.th, 8260 Viby J</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="text-white shrink-0 pt-1">
                <Phone className="w-6 h-6" />
              </div>
              <div>
                <p className="font-medium text-white">Telefon</p>
                <a href="tel:40938593" className="text-neutral-400 hover:text-white transition-colors mt-0.5 block whitespace-nowrap">
                  +45 40 93 85 93
                </a>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="text-white shrink-0 pt-1">
                <Mail className="w-6 h-6" />
              </div>
              <div>
                <p className="font-medium text-white">Email</p>
                <a href="mailto:info@johncalmar.dk" className="text-neutral-400 hover:text-white transition-colors mt-0.5 block whitespace-nowrap">
                  info@johncalmar.dk
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
